export var defaultProps = {
    className: '',
    multiple: false,
    data: {},
    action: '',
    headers: {},
    withCredentials: false,
    listType: 'text',
    type: 'select',
    disabled: false,
    name: 'file',
    method: 'post',
};
